import { Route, Switch, Redirect } from "react-router-dom";
import { SignInDt } from "./SignIn";
import { AUTH_DT_ROUTES, WORK_DIRECTON_BASE_PATH } from "../constants";
import { EnterPassword } from "./EnterPassword";

export const AuthDtRoutes = () => {
  return (
    (
      <Switch>
        <Route  path={AUTH_DT_ROUTES.SIGN_IN} component={SignInDt} />
        <Route  path={AUTH_DT_ROUTES.ENTER_PASSWORD} component={EnterPassword} />
        <Redirect from={WORK_DIRECTON_BASE_PATH} to={AUTH_DT_ROUTES.SIGN_IN} />
      </Switch>
    )
  )
}